import { render, staticRenderFns } from "./customer-edit.vue?vue&type=template&id=53bb338b&scoped=true"
import script from "./customer-edit.vue?vue&type=script&lang=js"
export * from "./customer-edit.vue?vue&type=script&lang=js"
import style0 from "./customer-edit.vue?vue&type=style&index=0&id=53bb338b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bb338b",
  null
  
)

export default component.exports